module.exports = __webpack_public_path__ + "static/media/shaff1148.01f304a9.jpg";